const isIOS = () => {
    return /iPad|iPhone|iPod|Macintosh/.test(navigator.userAgent) && !window.MSStream;
};

const getDate = (date, dateWithoutTime) => {
    const sDate = new Date();
    if (!date) {
        date = new Date(sDate);
    }
    date = new Date(date);
    let DATE_OPTIONS = {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
    };
    if (dateWithoutTime) {
        DATE_OPTIONS = {
            year: 'numeric',
            month: 'short',
            day: 'numeric'
        };
    }
    return date.toLocaleDateString('en-US', DATE_OPTIONS);
};

const getDateOnly = (date) => {
    return getDate(date, true);
};

const dateInRequireFormate = (param, formate) => {
    if (param === '' || param === null || (typeof param === 'object' && !Date.parse(param))) {
        return '';
    }
    const dateObj = new Date(param);
    if (isNaN(new Date(dateObj).getTime())) return 'NA';
    const month = dateObj.getMonth() + 1;
    const day = dateObj.getDate();
    const year = dateObj.getFullYear();
    const hours = dateObj.getHours();
    const min = dateObj.getMinutes();
    const seco = dateObj.getSeconds();
    switch (formate) {
        case 'm-d-y':
            return month + '-' + day + '-' + year;
        case 'd-m-y':
            return day + '-' + month + '-' + year;
        case 'm/d/y':
            return pad(month) + '/' + pad(day) + '/' + year;
        case 'm/d/y/t':
            return pad(month) + '/' + pad(day) + '/' + year + ' ' + pad(hours) + ':' + pad(min) + ':' + pad(seco);
        default:
            return year + '-' + month + '-' + day;
    }
};

const getUTCTime = (d) => {
    let date = new Date(d);
    return date === '' || date === null ? date : new Date(Date.UTC(date?.getFullYear(), date.getMonth(), date.getDate()));
};

function convertUTCDateToLocalDate(dateparam, format, convertUtc) {
    return dateparam === '' || dateparam === null
        ? dateparam
        : dateInRequireFormate(convertUTCToLocalDate(dateparam, '', convertUtc), format ? format : 'm/d/y');
}
function pad(n) {
    return n < 10 ? '0' + n : n;
}
function convertUTCToLocalDate(dateparam, format, convertUtc) {
    let now = new Date(dateparam);
    if (convertUtc) {
        now = new Date(dateparam + 'Z');
    }
    const localDateTime =
        now.getFullYear() +
        '-' +
        pad(now.getMonth() + 1) +
        '-' +
        pad(now.getDate()) +
        'T' +
        pad(now.getHours()) +
        ':' +
        pad(now.getMinutes()) +
        ':' +
        pad(now.getSeconds());
    return localDateTime;
}
const combineDateAndTime = (date, time) => {
    const mins = ('0' + time?.getMinutes())?.slice(-2);
    const hours = ('0' + time?.getHours())?.slice(-2);
    const seconds = ('0' + time?.getSeconds())?.slice(-2);
    const timeString = hours + ':' + mins + ':' + seconds;
    const year = date?.getFullYear();
    const month = ('0' + (date?.getMonth() + 1)).slice(-2);
    const day = ('0' + date?.getDate()).slice(-2);
    const dateString = '' + year + '-' + month + '-' + day;
    const datec = dateString + 'T' + timeString;
    return convertUTCToLocalDate(new Date(datec));
};

const getUTCDateTime = (dateObj) => {
    let selDateWithTime = combineDateAndTime(new Date(dateObj), new Date());
    return new Date(selDateWithTime).toISOString();
};

// Others
const uniqBy = (arr, predicate) => {
    const cb = typeof predicate === 'function' ? predicate : (o) => o[predicate];
    return [
        ...arr
            .reduce((map, item) => {
                const key = item === null || item === undefined ? item : cb(item);
                map.has(key) || map.set(key, item);
                return map;
            }, new Map())
            .values()
    ];
};

const uniqueID = (length) => {
    var result = '';
    var characters = 'abcdefghijklmnopqrstuvwxyz0123456789';
    var charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
};

const convertTextCase = (name, param) => {
    let result;
    if (param) {
        result = name?.charAt(0)?.toUpperCase() + name?.substr(1)?.toLowerCase();
    } else {
        result = name?.charAt(0)?.toUpperCase() + name?.substr(1);
    }
    return result;
};

function guid() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = (Math.random() * 16) | 0,
            v = c === 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
    });
}

const isDateInBetweenTwoDates = (startDate, endDate, checkDate) => {
    return new Date(checkDate) >= new Date(startDate) && new Date(checkDate) <= new Date(endDate);
};
// write a function to cut text into 200 characters
const cutTextInto200characters = (str) => {
    if (str.length > 200) {
        return str.substring(0, 200);
    } else {
        return str;
    }
};

const cutTextIntoSpecificCharacters = (str, number) => {
    if (str?.length > number) {
        return str?.substring(0, number);
    } else {
        return str;
    }
};
const customLineClamp = (str, number) => {
    if (str.length > number) {
        return str.substring(0, number) + '...';
    } else {
        return str;
    }
};

const convertToLowerCase = (str) => {
    return str && typeof str === 'string' ? str.toLowerCase() : str;
};
const convertToUpperCase = (str) => {
    return str && typeof str === 'string' ? str?.toUpperCase() : str;
};

const convertDateIntoDays = (date) => {
    // Get the current date
    const currentDate = new Date();

    // Specify the target date you want to compare with
    const targetDate = new Date(date); // Replace this with your desired target date

    // Calculate the difference between the target date and the current date in milliseconds
    const timeDifference = targetDate - currentDate;

    // Convert milliseconds difference to days
    const daysDifference = Math.floor(timeDifference / (1000 * 60 * 60 * 24));

    return daysDifference;
};

const getUtcDate = () => {
    const now = new Date();

    const year = now.getUTCFullYear();
    const month = now.getUTCMonth() + 1;
    const day = now.getUTCDate();
    const hours = now.getUTCHours();
    const minutes = now.getUTCMinutes();
    const seconds = now.getUTCSeconds();
    const milliseconds = now.getUTCMilliseconds();
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}.${milliseconds}`;
};
getUtcDate();

const calculateTimeSpan = (startDate, endDate) => {
    const timeDifference = endDate - startDate;

    // Calculate hours, minutes, and seconds
    const hours = Math.floor(timeDifference / 3600000);
    const minutes = Math.floor((timeDifference % 3600000) / 60000);
    const seconds = Math.floor((timeDifference % 60000) / 1000);

    // Format the result
    const formattedTimeSpan = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds
        .toString()
        .padStart(2, '0')}`;

    return formattedTimeSpan;
};

const getTenantConfig = (tenantId) => {
    switch (tenantId) {
        case '/marriott-anthem':
        case 19:
            return {
                REACT_APP_TRACK_AUTH_TOKEN: process.env.REACT_APP_MARRIOT_TRACK_AUTH_TOKEN,
                REACT_APP_TRACT_API_KEY: process.env.REACT_APP_MARRIOT_TRACT_API_KEY,
                REACT_APP_INITIATE_API_KEY: process.env.REACT_APP_MARRIOT_INITIATE_API_KEY,
                REACT_APP_INITIATE_AUTH_TOKEN: process.env.REACT_APP_MARRIOT_INITIATE_AUTH_TOKEN,
                REACT_APP_ASSESSMENT_ID: process.env.REACT_APP_MARRIOT_ASSESSMENT_ID,
                checkForDisableButton: false,
                umoja: false
            };
        case '/anthem':
        case 30:
            return {
                REACT_APP_TRACK_AUTH_TOKEN: process.env.REACT_APP_ANTHEM_TRACK_AUTH_TOKEN,
                REACT_APP_TRACT_API_KEY: process.env.REACT_APP_ANTHEM_TRACT_API_KEY,
                REACT_APP_INITIATE_API_KEY: process.env.REACT_APP_ANTHEM_INITIATE_API_KEY,
                REACT_APP_INITIATE_AUTH_TOKEN: process.env.REACT_APP_ANTHEM_INITIATE_AUTH_TOKEN,
                REACT_APP_ASSESSMENT_ID: process.env.REACT_APP_ANTHEM_ASSESSMENT_ID,
                checkForDisableButton: true,
                umoja: false
            };
        case '/umoja':
        case 288230376151711744:
        case 11701:
        case 400001:
            return {
                REACT_APP_TRACK_AUTH_TOKEN: process.env.REACT_APP_UMOJA_TRACK_AUTH_TOKEN,
                REACT_APP_TRACT_API_KEY: process.env.REACT_APP_UMOJA_TRACT_API_KEY,
                REACT_APP_INITIATE_API_KEY: process.env.REACT_APP_UMOJA_INITIATE_API_KEY,
                REACT_APP_INITIATE_AUTH_TOKEN: process.env.REACT_APP_UMOJA_INITIATE_AUTH_TOKEN,
                REACT_APP_ASSESSMENT_ID: process.env.REACT_APP_UMOJA_ASSESSMENT_ID,
                callCountyApi: true,
                umoja: true
            };
        default:
            // defaulting to marriot
            return {
                REACT_APP_TRACK_AUTH_TOKEN: process.env.REACT_APP_MARRIOT_TRACK_AUTH_TOKEN,
                REACT_APP_TRACT_API_KEY: process.env.REACT_APP_MARRIOT_TRACT_API_KEY,
                REACT_APP_INITIATE_API_KEY: process.env.REACT_APP_MARRIOT_INITIATE_API_KEY,
                REACT_APP_INITIATE_AUTH_TOKEN: process.env.REACT_APP_MARRIOT_INITIATE_AUTH_TOKEN,
                REACT_APP_ASSESSMENT_ID: process.env.REACT_APP_MARRIOT_ASSESSMENT_ID,
                checkForDisableButton: false,
                umoja: false
            };
    }
};

// const detectDeviceType = () =>
//     /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ? 'Mobile' : 'Desktop';

export {
    getDate,
    getDateOnly,
    getUTCTime,
    dateInRequireFormate,
    convertUTCDateToLocalDate,
    convertUTCToLocalDate,
    getUTCDateTime,
    uniqueID,
    convertTextCase,
    uniqBy,
    guid,
    combineDateAndTime,
    isDateInBetweenTwoDates,
    cutTextInto200characters,
    cutTextIntoSpecificCharacters,
    convertToLowerCase,
    convertToUpperCase,
    convertDateIntoDays,
    customLineClamp,
    calculateTimeSpan,
    isIOS,
    getTenantConfig
};
